import { useState } from 'react';

const PAGE_SIZE_KEY = 'studentTablePageSize';

export const useTablePagination = (totalItems: number) => {
  const [pageSize, setPageSize] = useState(() => {
    const savedSize = localStorage.getItem(PAGE_SIZE_KEY);
    return savedSize ? parseInt(savedSize, 10) : 10;
  });
  const [page, setPage] = useState(1);

  const handlePageChange = (_: unknown, value: number) => {
    setPage(value);
  };

  const handlePageSizeChange = (newSize: number) => {
    setPageSize(newSize);
    setPage(1);
    localStorage.setItem(PAGE_SIZE_KEY, newSize.toString());
  };

  const pageCount = Math.ceil(totalItems / pageSize);
  const startIndex = (page - 1) * pageSize;
  console.log('-----------------------------------------', startIndex, pageSize, page);
  const endIndex = Math.min(startIndex + pageSize, totalItems);

  return {
    page,
    pageSize,
    pageCount,
    startIndex,
    endIndex,
    handlePageChange,
    handlePageSizeChange
  };
};